/** 
=========================================================
* Vision UI PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

// @mui material components
import Grid from "@mui/material/Grid";
import breakpoints from "assets/theme/base/breakpoints";

// Vision UI Dashboard PRO React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import Footer from "examples/Footer";

// Vision UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Redux
import { useSelector } from "react-redux";
import Loading from "components/shared-components/Loading";
import WarningMessage from "../warning";

import { HeaderWidgets } from "./HeaderWidgets";
import GoogleChart from "views/app-views/dashboards/google/GoogleChart";
import { GoogleOverview } from "views/app-views/dashboards/google/GoogleOverview";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import NoMerchantWarning from "components/shared-components/NoMerchantWarning";

function GoogleDashboard() {
  const { values } = breakpoints;
  const selectedMer = useSelector(
    (state: any) => state.merchants.selectedMerchant
  );
  const { isFeatureEnabled } = useFeatureFlag();
  const googleData = useSelector((state: any) => state.googleData.data);

  if (!selectedMer?.id) {
    return <NoMerchantWarning />;
  }

  if (!isFeatureEnabled("enabled_google_dashboard", false)) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <Grid container mt={10} justifyContent="center">
          <Grid item xs={12} md={6}>
            <WarningMessage
              text="404"
              detail="There's nothing here"
              url="/app/"
              actionText="Back to Dashboard"
            />
          </Grid>
        </Grid>
      </DashboardLayout>
    )
  }

  if (!selectedMer?.googleConnected) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <Grid container mt={10} justifyContent="center">
          <Grid item xs={12} md={6}>
            <WarningMessage
              text="Google not connected"
              detail="Please connect your Google account to view this dashboard"
              url="/app/settings/store-connections"
              actionText="Connect Google"
            />
          </Grid>
        </Grid>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={3}>
        <Grid container>
          <Grid item xs={12}>
            <VuiBox mb={3} p={1}>
              <VuiTypography
                variant={window.innerWidth < values.sm ? "h3" : "h2"}
                textTransform="capitalize"
                fontWeight="bold"
                color="white"
              >
                Google Dashboard
              </VuiTypography>
            </VuiBox>
          </Grid>
          <Grid container spacing={3}>
            <HeaderWidgets />
          </Grid>
          <Grid item xs={12} mb={3}>
            {googleData?.graphData?.length > 0 && (
              <GoogleChart
                googleAdsData={googleData || { graphData: [] }}
              />
            )}
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <VuiBox mb={3}>
                <GoogleOverview
                  title="Google Overview"
                  googleData={googleData}
                  loading={googleData?.overview?.loading || false}
                  timezone={selectedMer?.timezone}
                  currency={selectedMer?.currency}
                />
              </VuiBox>
            </Grid>
          </Grid>
        </Grid>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default GoogleDashboard; 